import React from "react";

/**
 * Fila de íconos al pie del hero del login.
 *
 * Sale del manual de marca, no de un banco de imágenes: la iconografía
 * (pág. 15) es un sistema de línea, trazo uniforme, terminaciones
 * redondeadas, un solo color —blanco sobre fondo oscuro— y contenedor
 * circular. La fórmula "claim + fila de íconos en círculo" es la que usan
 * las piezas oficiales de comunicación (pág. 18).
 *
 * Van dibujados como SVG inline y no como imagen: pesan bytes en vez de
 * cientos de KB, quedan nítidos en cualquier pantalla y acompañan el color
 * del texto sin pedir un archivo por variante.
 *
 * Ojo con qué se muestra acá: el login se ve ANTES de autenticarse, así que
 * no hay empresa, ni rol, ni módulos contratados. Esta fila es vidriera de
 * marca, igual para todos los tenants, no el menú de lo que el usuario va a
 * poder abrir. Por eso van los módulos más representativos del rubro y no
 * los que tenga habilitados tal o cual cliente.
 */

const ICON = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
};

const FEATURES = [
    {
        label: "Supervisión",
        path: (
            <>
                <rect x="4.5" y="4.5" width="15" height="16" rx="2.5" />
                <rect x="9" y="2.5" width="6" height="4" rx="1.5" />
                <path d="M8.5 11h7M8.5 14.5h3.5" />
                <path d="M13.5 17.2l2 2 3.6-3.9" />
            </>
        ),
    },
    {
        label: "Asistencia",
        path: (
            <>
                <circle cx="11" cy="8.5" r="3.5" />
                <path d="M4.5 19.5a6.5 6.5 0 0 1 11-4.7" />
                <path d="M14.4 17.8l2 2 3.6-3.9" />
            </>
        ),
    },
    {
        label: "Rondas",
        path: (
            <>
                <rect x="3.5" y="5.5" width="17" height="15" rx="2.5" />
                <path d="M3.5 10.5h17M8 3v4.5M16 3v4.5" />
                <path d="M9 15.2l2.4 2.4 4-4.4" />
            </>
        ),
    },
    {
        label: "Análisis de Riesgo",
        path: (
            <>
                <path d="M12 4.2 21 19.4a1 1 0 0 1-.9 1.5H3.9a1 1 0 0 1-.9-1.5z" />
                <path d="M12 10v4.2" />
                <path d="M12 17.4h.01" />
            </>
        ),
    },
    {
        label: "Auditorías",
        path: (
            <>
                <circle cx="10.5" cy="10.5" r="6.6" />
                <path d="m15.5 15.5 4.2 4.2" />
                <path d="m7.7 10.6 2 2 3.5-3.9" />
            </>
        ),
    },
    {
        label: "Capacitaciones",
        path: (
            <>
                <path d="M12 3l7 2.7v5.4c0 4.3-2.9 8.1-7 9.4-4.1-1.3-7-5.1-7-9.4V5.7z" />
                <path d="M8.9 12.1l2.4 2.4 4.1-4.6" />
            </>
        ),
    },
];

const LoginHeroFeatures = ({ count = 5 }) => (
    <ul className="login-hero-features">
        {FEATURES.slice(0, count).map(({ label, path }) => (
            <li key={label} className="login-hero-feature">
                <span className="login-hero-feature-icon">
                    <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" {...ICON}>
                        {path}
                    </svg>
                </span>
                {label}
            </li>
        ))}
    </ul>
);

export default LoginHeroFeatures;
